__turbopack_context__.v({
  "className": "source_sans_3_e33640e-module__ESSyXa__className",
  "variable": "source_sans_3_e33640e-module__ESSyXa__variable",
});
